import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { EnterpriseDetailPage } from '@/features/enterprise/detail-page';

export const Route = createFileRoute(
  '/_authenticated/operations/enterprises/$enterpriseId',
)({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'enterprises:read'),
  component: EnterpriseRoute,
});

function EnterpriseRoute() {
  const { enterpriseId } = Route.useParams();
  return <EnterpriseDetailPage enterpriseId={enterpriseId} />;
}
